import React, { useEffect, useRef, useState } from "react";
import { getCSRFToken } from "../utils/csrf";

const UPLOAD_FILE = "/escuela/archivos/upload/";

export const FileUploader = ({ onChange, show = false }) => {
  const dropzoneRef = useRef(null);
  const fileInputRef = useRef(null);

  const [hidden, setHidden] = useState(true);
  const handleFiles = (files) => {
    [...files].forEach(uploadFile);
  };

  useEffect(() => {
    const handleDragOver = (e) => {
      e.preventDefault();
      setHidden(false);
    };
    const handleDragLeave = (e) => {
      setHidden(true);
    };
    document.addEventListener("dragover", handleDragOver);
    document.addEventListener("dragleave", handleDragLeave);
    document.addEventListener("drop", handleDragLeave);

    return () => {
      document.removeEventListener("dragover", handleDragOver);
      document.removeEventListener("dragleave", handleDragLeave);
      document.removeEventListener("drop", handleDragLeave);
    };
  }, []);

  const uploadFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    fetch(UPLOAD_FILE, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRFToken": getCSRFToken(),
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error al subir");
        return response.json();
      })
      .then((apiResponse) => {
        onChange?.([apiResponse]);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDrop = (e) => {
    setHidden(true);
    e.preventDefault();
    e.stopPropagation();
    dropzoneRef.current.classList.remove("dragover");
    handleFiles(e.dataTransfer.files);
  };

  const handleDragEnterOver = (e) => {
    setHidden(false);
    e.preventDefault();
    e.stopPropagation();
    dropzoneRef.current.classList.add("dragover");
  };

  const handleDragLeaveDrop = (e) => {
    setHidden(true);
    e.preventDefault();
    e.stopPropagation();
    dropzoneRef.current.classList.remove("dragover");
  };

  return (
    <div hidden={hidden}>
      <div
        id="dropzone"
        ref={dropzoneRef}
        className="dropzone"
        onClick={() => fileInputRef.current.click()}
        onDragEnter={handleDragEnterOver}
        onDragOver={handleDragEnterOver}
        onDragLeave={handleDragLeaveDrop}
        onDrop={handleDrop}
      >
        Arrastrá los archivos aquí o hacé clic para seleccionarlos.
        <input
          type="file"
          id="fileInput"
          multiple
          hidden
          ref={fileInputRef}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
    </div>
  );
};

export default FileUploader;
